import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import ProtectedRoute from './components/auth/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import OfferListPage from './pages/offers/OfferListPage';
import OfferCreatePage from './pages/offers/OfferCreatePage';
import OfferEditPage from './pages/offers/OfferEditPage';
import DestinationListPage from './pages/destinations/DestinationListPage';
import DestinationCreatePage from './pages/destinations/DestinationCreatePage';
import DestinationEditPage from './pages/destinations/DestinationEditPage';
import PackageListPage from './pages/packages/PackageListPage';
import PackageCreatePage from './pages/packages/PackageCreatePage';
import PackageEditPage from './pages/packages/PackageEditPage';
import HotelListPage from './pages/hotels/HotelListPage';
import HotelCreatePage from './pages/hotels/HotelCreatePage';
import HotelEditPage from './pages/hotels/HotelEditPage';
import ExcursionListPage from './pages/excursions/ExcursionListPage';
import ExcursionFormPage from './pages/excursions/ExcursionFormPage';
import BookingListPage from './pages/bookings/BookingListPage';
import BookingCreatePage from './pages/bookings/BookingCreatePage';
import BookingEditPage from './pages/bookings/BookingEditPage';
import BookingDetailPage from './pages/bookings/BookingDetailPage';
import BlogListPage from './pages/blog/BlogListPage';
import BlogCreatePage from './pages/blog/BlogCreatePage';
import BlogEditPage from './pages/blog/BlogEditPage';
import UserListPage from './pages/users/UserListPage';
import UserCreatePage from './pages/users/UserCreatePage';
import UserEditPage from './pages/users/UserEditPage';
import SettingsPage from './pages/settings/SettingsPage';
import NotFoundPage from './pages/NotFoundPage';
import UnauthorizedPage from './pages/UnauthorizedPage';
import { isAuthenticated } from './utils/auth';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={
          isAuthenticated() ? <Navigate to="/dashboard" replace /> : <LoginPage />
        } />

        {/* Auth error routes */}
        <Route path="/unauthorized" element={<UnauthorizedPage />} />

        {/* Protected routes */}
        <Route path="/" element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<BookingListPage />} />
          {/* <Route path="dashboard" element={<DashboardPage />} /> */}

          {/* Offers routes */}
          {/* <Route path="offers" element={<OfferListPage />} />
          <Route path="offers/create" element={<OfferCreatePage />} />
          <Route path="offers/edit/:id" element={<OfferEditPage />} /> */}

          {/* Destinations routes */}
          {/* <Route path="destinations" element={<DestinationListPage />} />
          <Route path="destinations/create" element={<DestinationCreatePage />} />
          <Route path="destinations/edit/:slug" element={<DestinationEditPage />} /> */}

          {/* Packages routes */}
          {/* <Route path="packages" element={<PackageListPage />} />
          <Route path="packages/create" element={<PackageCreatePage />} />
          <Route path="packages/edit/:slug" element={<PackageEditPage />} /> */}

          {/* Hotels routes */}
          {/* <Route path="hotels" element={<HotelListPage />} />
          <Route path="hotels/create" element={<HotelCreatePage />} />
          <Route path="hotels/edit/:slug" element={<HotelEditPage />} /> */}

          {/* Excursions routes */}
          {/* <Route path="excursions" element={<ExcursionListPage />} />
          <Route path="excursions/create" element={<ExcursionFormPage />} />
          <Route path="excursions/edit/:slug" element={<ExcursionFormPage />} /> */}

          {/* Bookings routes */}
          <Route path="bookings" element={<BookingListPage />} />
          {/* <Route path="bookings/create" element={<BookingCreatePage />} /> */}
          <Route path="bookings/edit/:id" element={<BookingEditPage />} />
          <Route path="bookings/detail/:id" element={<BookingDetailPage />} />

          {/* Blog routes */}
          {/* <Route path="blog" element={<BlogListPage />} />
          <Route path="blog/create" element={<BlogCreatePage />} />
          <Route path="blog/edit/:slug" element={<BlogEditPage />} /> */}

          {/* User routes */}
          {/* <Route path="users" element={<UserListPage />} />
          <Route path="users/create" element={<UserCreatePage />} />
          <Route path="users/edit/:id" element={<UserEditPage />} /> */}

          {/* Settings routes */}
          {/* <Route path="settings" element={<SettingsPage />} /> */}

          {/* Add more routes here */}
        </Route>

        {/* 404 route */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;
